<template>
    <div>
        <breadcrumb :routerList="[{to:'/yuce/sellOn_list',title:'市场预测'},{title:'内销预测详情'}]"/>
        <div class="h-content">
            <div v-if="showForm" class="h-piece">
				<el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
					<div class="h-formBox w-formBox">
						<div class="tow-formBox">
							<el-form-item label="客户名称">
								<el-input v-model="formInline.customer"></el-input>
							</el-form-item>
							<el-form-item label="销售渠道">
								<brselect placeholder="请选择"
										  category="sales_region"
										  :v="formInline.trench"
										  clearable
										  v-model="formInline.trench">
								</brselect>
							</el-form-item>
						</div>
						<el-from-item>
							<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
						</el-from-item>
					</div>
				</el-form>
            </div>
            <div class="h-table h-mrt30">
                <el-table
                        ref="multipleTable"
                        :data="tableData"
                        stripe
						border
						max-height="500"
                        style="width: 100%">
                    <el-table-column
                            fixed
                            type="index"
                            width="40"
                            label="#">
                    </el-table-column>
                    <el-table-column
                            prop="customer"
                            :show-overflow-tooltip="true"
                            label="客户名称"
                            min-width="180">
							<template slot-scope="scope">
								<div style="text-align: left;">{{scope.row.customer}}</div>
							</template>
                    </el-table-column>
                    <el-table-column
                            prop="trench"
                            :show-overflow-tooltip="true"
                            label="渠道"
                            width="80">
                        <template slot-scope="scope">
                            <dictname category="sales_region"  :v="scope.row.trench"/>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="targetUser"
                            :show-overflow-tooltip="true"
                            label="目标用户"
                            min-width="180">
							<template slot-scope="scope">
								<div style="text-align: left;">{{scope.row.targetUser}}</div>
							</template>
                    </el-table-column>
                    <el-table-column
                            prop="productType"
                            :show-overflow-tooltip="true"
                            label="产品大类"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop="productModel"
                            :show-overflow-tooltip="true"
                            label="产品型号"
                            width="150">
								<template slot-scope="scope">
								    <div style="text-align: left;">
								        {{scope.row.productModel}}
								    </div>
								</template>
                    </el-table-column>
                    <el-table-column
                            prop="num"
                            :show-overflow-tooltip="true"
                            label="数量"
                            width="60">
								<template slot-scope="scope">
									<div style="text-align: right;">
										{{scope.row.num}}
									</div>
								</template>
                    </el-table-column>
                    <el-table-column
                            prop="price"
                            :show-overflow-tooltip="true"
                            label="单价(元)"
                            width="90">
								<template slot-scope="scope">
									<div style="text-align: right;">
										{{scope.row.price}}
									</div>
								</template>
                    </el-table-column>
                    <el-table-column
                            prop="totalSales"
                            :show-overflow-tooltip="true"
                            label="总销额(元)"
                            width="100">
								<template slot-scope="scope">
									<div style="text-align: right;">
										{{scope.row.totalSales}}
									</div>
								</template>
                    </el-table-column>
                    <el-table-column
                            prop="income"
                            :show-overflow-tooltip="true"
                            label="收入(元)"
                            width="90">
								<template slot-scope="scope">
									<div style="text-align: right;">
										{{scope.row.income}}
									</div>
								</template>
                    </el-table-column>
                    <el-table-column
                            prop="formationTime"
                            :show-overflow-tooltip="true"
                            label="预计成单日期"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="week"
                            :show-overflow-tooltip="true"
                            label="第几周"
                            width="80">
                    </el-table-column>
                    <el-table-column
                            prop="cdate"
                            :show-overflow-tooltip="true"
                            label="创建时间"
                            width="160">
                    </el-table-column>
                    <el-table-column
                            prop="orderType"
                            :show-overflow-tooltip="true"
                            label="订单类型"
                            width="90">
                        <template slot-scope="scope">
                            <dictname category="yuce_type"  :v="scope.row.orderType"/>
                        </template>
                    </el-table-column>
                </el-table>
                <div v-if="showDa" class="h-tableSummary">
                    <div class="h-tSummaryItem">
                        <span style="height: 0.5rem;line-height: 0.48rem;font-size: 0.16rem;">履约率</span>
                        <span v-if="showNum" style="color: #c61c1c;height: 0.5rem;line-height: 0.48rem;font-size: 0.16rem;" class="h-redFont">警示（0%）</span>
                        <span v-if="showGreen" style="color: #21d06f;height: 0.5rem;line-height: 0.48rem;font-size: 0.16rem;" class="h-greenFont">履约（{{numb}}%） </span>
                        <span v-if="showBlue" style="color: #2785e7;height: 0.5rem;line-height: 0.48rem;font-size: 0.16rem;" class="h-blueFont">达标（{{numb}}%）</span>
                        <span v-if="showRed" style="color: #c61c1c;height: 0.5rem;line-height: 0.48rem;font-size: 0.16rem;" class="h-redFont">警示（{{numb}}%）</span>
                    </div>
                    <div class="h-tSummaryItem">
                        <span style="height: 0.5rem;line-height: 0.48rem;font-size: 0.16rem;">签约目标</span>
                        <span style="height: 0.5rem;line-height: 0.48rem;font-size: 0.16rem;">{{target}}万</span>
                    </div>
                    <div class="h-tSummaryItem">
                        <span style="height: 0.5rem;line-height: 0.48rem;font-size: 0.16rem;">销单预测金额</span>
                        <span style="height: 0.5rem;line-height: 0.48rem;font-size: 0.16rem;">{{totalMon}}万</span>
                    </div>
                </div>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
                    </div>
                    <div class="h-pagination2 h-pageCenter">
                        <pagination :page="formInline" @query="handleFilter"/>
                    </div>
                </div>
            </div>
<!--            <div class="h-table h-mrt30    bbbb" v-if="showText">-->
<!--                <div class="h-pieceTitle2 hang">-->
<!--                    <h1 class="h1">审批意见</h1>-->
<!--                    <el-form :model="formLabelAlign" label-position="right" :inline="true"-->
<!--                             class="demo-ruleForm h-formbLine inputO" >-->
<!--                        <el-form-item label="审批意见" class="h-elformWrap-2 " :required="true"-->
<!--                                      style="margin:30px 0 20px 29px">-->
<!--                            <el-input v-model="shenhetext" class="zidaoO" placeholder="无审核意见" disabled></el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-form>-->

<!--                </div>-->
<!--            </div>-->
            <div class="apprButton">
				<el-button class="h-btn h-bBtn h-bgblueQ2" @click="returnTable">返回</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import big from 'big.js'
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'

    export default {
        data() {
            return {
                shenhetext:'',
                //查询属性
                // q: {
                //     pageSize: 20,
                //     pageNo: 1,
                //     total: 0,
                //     bid: '',
                //     formation: '',
                //     productCode: '',
                // },
                //表单
                formInline: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    bid: '',
                    formation: '',
                    productCode: '',
                },
                //表格
                tableData: [],
                formLabelAlign:{},
                table:{
                    Data: [],
                    optflag: '',
                    yijianMsg: '',
                    aaa: '',
                    taskId: '',
                },
                totalMon: 0,
                tot: 0,
                opt: [],
                userRole: [],
                a: 10,
                showGreen: false,
                showBlue: false,
                showRed: false,
                showNum: true,
                uArea: '',
                showArea1: false,
                showArea2: false,
                showDa: false,
                showP: false,
                showForm: false,
                // showText: false,
                target: '',
                numb: ''
            }
        },
        mounted() {
        },
        created() {
            // this.q.bid = this.$route.query.id;
            // this.q.formation = this.$route.query.month;
            // this.q.productCode = this.$route.query.proCode;
            this.formInline.bid = this.$route.query.id;
            this.formInline.formation = this.$route.query.month;
            this.formInline.productCode = this.$route.query.proCode;
            this.showList();
        },
        beforeRouteLeave(to,from,next){
            if((to.path=='/yuce/domesticList_screening' || to.path=='/yuce/sellOn_list') && from.path == '/yuce/xiangqing'){
                to.meta.keepAlive = true;
            }else{
                to.meta.keepAlive = false;
            }
            next();
        },
        methods: {
            // 重置按钮
            resetData(){
                this.formInline.customer = '';
                this.formInline.trench = '';
                this.formInline.pageSize = 10;
                this.showList();
            },
            //明细导出
            exportExcel() {
                var idlist=[];
                this.tableData.forEach(element => {
                    idlist.push(element.id);
                });
                updownfile.down("/api/swyl/v1/demo/bscForecastplanDetailed/downloadExcel",idlist,"post",'data');
            },
            editor() {
                var bid = this.$route.query.id;
                this.$router.push({path: "/yuce/pingshen", query: {bid: bid}})
            },
            handleFilter() {
                this.query();
            },
            showList() {
                if (this._user.usertype != 1) {
                    this.userRole = this._user.roles;
                    this.userRole.forEach((item, index) => {
                        if (item.id == "swyl_admin") {
                            this.a = 1;
                            return
                        }
                        if (item.id == "swyl_quyujl") {
                            this.a = 0;
                        }
                    })
                }
                var code = this._user.usercode;
                ss.pingshen.showTarget(code).then(rd => {
                    if (rd) {
                        this.target = rd;
                        //将签约目标变成万
                        this.target = new big(this.target).div(10000);
                    } else {
                        this.target = 0;
                    }
                })
                ss.pingshen.showPage(this.formInline).then(rd => {
                    this.formInline.total = rd.total;
                    this.tableData = rd.records;
                    // this.tableData.forEach((item, index) => {
                    //     var date = item.cdate;
                    //     var timestamp = new Date(date);
                    //     var year = timestamp.getFullYear(); //获取当前日期的年份
                    //     var month = timestamp.getMonth() + 1; //获取当前日期的月份
                    //     if (month<10) {
                    //         month = "0"+month;
                    //     }
                    //     var day = timestamp.getDate();
                    //     console.log("sdsdsd", year + "-" + month + "-" + day);
                    //     item.cdate = year + "-" + month + "-" + day;
                    // })
                    this.totalMon = 0;
                    rd.records.forEach((item, index) => {
                        this.totalMon = new big(parseInt(this.totalMon)).plus(parseInt(item.totalSales));
                    })
                    this.totalMon = this.totalMon.div(10000);

                    // this.formInline.customer = this._user.username;
                    // this.uName = this._user.username;
                    if (this._user.usertype == 1) {
                        this.showForm = false;
                        this.showP = false;
                        this.showArea1 = false;
                        this.showDa = true;
                        this.showArea2 = true;
                        if (this.formInline.bid == undefined || this.formInline.bid == null || this.formInline.bid == '') {
                            this.showDa = false;
                        }
                        this.formInline.area = this._user.area;
                        this.uArea = this.$getDictName('YLRegion', this._user.area);
                    }
                    if (this.a == 0) {
                        this.showForm = false;
                        this.showP = false;
                        this.showArea1 = false;
                        this.showArea2 = true;
                        this.showDa = false
                        this.formInline.area = this._user.area;
                        this.uArea = this.$getDictName('YLRegion', this._user.area);
                    }
                    if (this.a == 1) {
                        this.showForm = true;
                        this.showP = true;
                        this.showArea1 = true;
                        this.showArea2 = false;
                        this.showDa = false;
                        // this.showText = false;
                    }
                    if (this.target == 0) {
                        this.numb = 100
                    } else {
                        this.numb = this.totalMon.div(this.target);
                        this.numb = this.numb.times(100);
                        this.numb = this.numb.toFixed(2);
                    }
                    if (this.numb < 70) {
                        this.showRed = true;
                        this.showBlue = false;
                        this.showGreen = false;
                        this.showNum = false;
                    }
                    if (this.numb >= 70 && this.numb < 100) {
                        this.showBlue = true;
                        this.showRed = false;
                        this.showGreen = false;
                        this.showNum = false;
                    }
                    if (this.numb >= 100) {
                        this.showGreen = true;
                        this.showBlue = false;
                        this.showRed = false;
                        this.showNum = false;
                    }
                })
            },
            query() {
                ss.pingshen.page(this.formInline).then(rd => {
                    this.formInline.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            showLevName() {
                ss.pingshen.showLName().then(rd => {
                    this.opt = rd;
                })
            },
            auditPass() {
                this.table.aaa = 2
                this.table.optflag = '审核通过';
                this.table.yijianMsg = this.shenhetext;
                this.table.Data = this.tableData;
                ss.pingshen.shTG(this.table).then(rd => {
                    this.$msg.msgs(rd.msg);
                    this.showList();
                })
            },
            auditFail() {
                this.table.aaa = 1
                this.table.optflag = '审核被驳回';
                this.table.yijianMsg = this.shenhetext;
                this.table.Data = this.tableData;
                ss.pingshen.shBTG(this.table).then(rd => {
                    this.$msg.msgs(rd.msg);
                    this.showList();
                })
            },
            returnTable() {
                // this.showNums();
                this.$router.go(-1);
            },
            // showNums() {
            //     ss.pingshen.showNum().then(rd => {
            //         console.log(rd,"我运行了");
            //     })
            // }
        }
    }
</script>
<style scoped>
    /*--------------- 审批样式 ----------------*/
    .inputO{
        margin-top: 19px;
    }

    .h1{
        margin: 20px 0 0 31px;
    }
    .bbbb{
        background-color: white;
        padding-bottom: 30px;
    }
    .redStar {
        position: absolute;
        top: 90%;
        left: 1%;
        color: red;
        font-size: 0.2rem;
    }

    .yijianbixutian {
        position: absolute;
        top: 1%;
        left: 15%;
        color: red;
    }


    .apprButton {
		width: 100%;
		margin-top: 0.2rem;
        padding-bottom: 0.2rem;
		display: flex;
		justify-content: center;
		align-items: center;
    }

    .cancel {
        width: 18%;
    }

    .pass {
        background-color: #006aca;
        color: white;
        width: 18%;
    }

    .refuse {
        background-color: #24b5b8;
        color: white;
        width: 18%;
    }

    /*--------------- 审批样式 ------------------*/
</style>
